import "./sp-button-fa52iiKJ.js";
import { a as h } from "./focusable-2cSgEeBs.js";
import { r as u } from "./random-id-aENvrLj2.js";
import { c as d } from "./condition-attribute-with-id-DpTOoDfo.js";
import { s as p } from "./resize-controller-BnQNYLHb.js";
import { i as v, x as a } from "./lit-element-6iugfgmM.js";
import { i as b } from "./query-D8_rwLua.js";
import { n as f } from "./property-BWlAHqg_.js";
import { S as y } from "./Base-pdJ5fkYW.js";
const w = v`
    :host{--spectrum-alert-dialog-min-width:var(--spectrum-alert-dialog-minimum-width);--spectrum-alert-dialog-max-width:var(--spectrum-alert-dialog-maximum-width);--spectrum-alert-dialog-icon-size:var(--spectrum-workflow-icon-size-100);--spectrum-alert-dialog-warning-icon-color:var(--spectrum-notice-visual-color);--spectrum-alert-dialog-error-icon-color:var(--spectrum-negative-visual-color);--spectrum-alert-dialog-title-font-family:var(--spectrum-sans-font-family-stack);--spectrum-alert-dialog-title-font-weight:var(--spectrum-heading-sans-serif-font-weight);--spectrum-alert-dialog-title-font-style:var(--spectrum-heading-sans-serif-font-style);--spectrum-alert-dialog-title-font-size:var(--spectrum-alert-dialog-title-size);--spectrum-alert-dialog-title-line-height:var(--spectrum-heading-line-height);--spectrum-alert-dialog-title-color:var(--spectrum-heading-color);--spectrum-alert-dialog-body-font-family:var(--spectrum-sans-font-family-stack);--spectrum-alert-dialog-body-font-weight:var(--spectrum-body-sans-serif-font-weight);--spectrum-alert-dialog-body-font-style:var(--spectrum-body-sans-serif-font-style);--spectrum-alert-dialog-body-font-size:var(--spectrum-alert-dialog-description-size);--spectrum-alert-dialog-body-line-height:var(--spectrum-line-height-100);--spectrum-alert-dialog-body-color:var(--spectrum-body-color);--spectrum-alert-dialog-title-to-divider:var(--spectrum-spacing-200);--spectrum-alert-dialog-divider-to-description:var(--spectrum-spacing-300);--spectrum-alert-dialog-title-to-icon:var(--spectrum-spacing-300);--mod-buttongroup-justify-content:flex-end;box-sizing:border-box;inline-size:fit-content;min-inline-size:var(--mod-alert-dialog-min-width,var(--spectrum-alert-dialog-min-width));max-inline-size:var(--mod-alert-dialog-max-width,var(--spectrum-alert-dialog-max-width));max-block-size:inherit;padding:var(--mod-alert-dialog-padding,var(--spectrum-alert-dialog-padding));outline:none;display:flex}.icon{inline-size:var(--mod-alert-dialog-icon-size,var(--spectrum-alert-dialog-icon-size));block-size:var(--mod-alert-dialog-icon-size,var(--spectrum-alert-dialog-icon-size));flex-shrink:0;margin-inline-start:var(--mod-alert-dialog-title-to-icon,var(--spectrum-alert-dialog-title-to-icon))}:host([variant=warning]){--mod-icon-color:var(--mod-alert-dialog-warning-icon-color,var(--spectrum-alert-dialog-warning-icon-color))}:host([variant=error]){--mod-icon-color:var(--mod-alert-dialog-error-icon-color,var(--spectrum-alert-dialog-error-icon-color))}.grid{display:grid}.header{justify-content:space-between;align-items:baseline;display:flex}::slotted([slot=heading]){font-family:var(--mod-alert-dialog-title-font-family,var(--spectrum-alert-dialog-title-font-family));font-weight:var(--mod-alert-dialog-title-font-weight,var(--spectrum-alert-dialog-title-font-weight));font-style:var(--mod-alert-dialog-title-font-style,var(--spectrum-alert-dialog-title-font-style));font-size:var(--mod-alert-dialog-title-font-size,var(--spectrum-alert-dialog-title-font-size));line-height:var(--mod-alert-dialog-title-line-height,var(--spectrum-alert-dialog-title-line-height));color:var(--mod-alert-dialog-title-color,var(--spectrum-alert-dialog-title-color));margin:0;margin-block-end:var(--mod-alert-dialog-title-to-divider,var(--spectrum-alert-dialog-title-to-divider))}.content{font-family:var(--mod-alert-dialog-body-font-family,var(--spectrum-alert-dialog-body-font-family));font-weight:var(--mod-alert-dialog-body-font-weight,var(--spectrum-alert-dialog-body-font-weight));font-style:var(--mod-alert-dialog-body-font-style,var(--spectrum-alert-dialog-body-font-style));font-size:var(--mod-alert-dialog-body-font-size,var(--spectrum-alert-dialog-body-font-size));line-height:var(--mod-alert-dialog-body-line-height,var(--spectrum-alert-dialog-body-line-height));color:var(--mod-alert-dialog-body-color,var(--spectrum-alert-dialog-body-color));-webkit-overflow-scrolling:touch;margin:0;margin-block-start:var(--mod-alert-dialog-divider-to-description,var(--spectrum-alert-dialog-divider-to-description));margin-block-end:var(--mod-alert-dialog-description-to-buttons,var(--spectrum-alert-dialog-description-to-buttons));overflow-y:auto}@media (forced-colors:active){:host{border:solid}}
`;
var z = Object.defineProperty, x = Object.getOwnPropertyDescriptor, m = (l, t, e, i) => {
  for (var o, r = i > 1 ? void 0 : i ? x(t, e) : t, s = l.length - 1; s >= 0; s--) (o = l[s]) && (r = (i ? o(t, e, r) : o(r)) || r);
  return i && r && z(t, e, r), r;
};
const C = ["confirmation", "information", "warning", "error", "destructive", "secondary"];
function g(l, t) {
  const e = l.assignedElements(), i = [];
  return e.forEach((o) => {
    if (o.id) i.push(o.id);
    else {
      const r = t + `-${u()}`;
      o.id = r, i.push(r);
    }
  }), i;
}
const n = class c extends h(y) {
  constructor() {
    super(...arguments), this.resizeController = new p(this, { callback: () => {
      this.shouldManageTabOrderForScrolling();
    } }), this._variant = "", this.labelledbyId = "sp-dialog-label-" + c.instanceCount++, this.shouldManageTabOrderForScrolling = () => {
      if (!this.contentElement) return;
      const { offsetHeight: t, scrollHeight: e } = this.contentElement;
      t < e ? this.contentElement.tabIndex = 0 : this.contentElement.removeAttribute("tabindex");
    }, this.describedbyId = "sp-dialog-description-" + c.instanceCount++;
  }
  static get styles() {
    return [w];
  }
  set variant(t) {
    if (t === this.variant) return;
    const e = this.variant;
    C.includes(t) ? (this.setAttribute("variant", t), this._variant = t) : (this.removeAttribute("variant"), this._variant = ""), this.requestUpdate("variant", e);
  }
  get variant() {
    return this._variant;
  }
  renderIcon() {
    switch (this.variant) {
      case "warning":
      case "error":
        return a`
                    <sp-icon-alert class="icon"></sp-icon-alert>
                `;
      default:
        return a``;
    }
  }
  renderHeading() {
    return a`
            <slot name="heading" @slotchange=${this.onHeadingSlotchange}></slot>
        `;
  }
  renderContent() {
    return a`
            <div class="content">
                <slot @slotchange=${this.onContentSlotChange}></slot>
            </div>
        `;
  }
  onHeadingSlotchange({ target: t }) {
    this.conditionLabelledby && (this.conditionLabelledby(), delete this.conditionLabelledby);
    const e = g(t, this.labelledbyId);
    e.length && (this.conditionLabelledby = d(this, "aria-labelledby", e));
  }
  onContentSlotChange({ target: t }) {
    requestAnimationFrame(() => {
      this.resizeController.unobserve(this.contentElement), this.resizeController.observe(this.contentElement);
    }), this.conditionDescribedby && (this.conditionDescribedby(), delete this.conditionDescribedby);
    const e = g(t, this.describedbyId);
    if (e.length && e.length < 4) this.conditionDescribedby = d(this, "aria-describedby", e);
    else if (!e.length) {
      const i = !!this.id;
      i || (this.id = this.describedbyId);
      const o = d(this, "aria-describedby", this.id);
      this.conditionDescribedby = () => {
        o(), i || this.removeAttribute("id");
      };
    }
  }
  renderButtons() {
    return a`
            <sp-button-group class="button-group">
                <slot name="button"></slot>
            </sp-button-group>
        `;
  }
  render() {
    return a`
            <div class="grid">
                <div class="header">
                    ${this.renderHeading()} ${this.renderIcon()}
                </div>
                <sp-divider size="m" class="divider"></sp-divider>
                ${this.renderContent()} ${this.renderButtons()}
            </div>
        `;
  }
};
n.instanceCount = 0, m([b(".content")], n.prototype, "contentElement", 2), m([f({ type: String, reflect: !0 })], n.prototype, "variant", 1);
let j = n;
export {
  j as A
};
//# sourceMappingURL=AlertDialog-DZxlMcbq.js.map
